import { userConstants } from "../../constant";
export function product(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_PRODUCT:
      return action.data;
    default:
      return state;
  }
}
